import angular from 'angular';

import svgUploadModule from '../svg.upload/svg.upload.module';
import { partPopup } from './directives/project.part.popup/project.part.popup.directive';
import { projectPartShortInfo } from './directives/project.part.short.info/project.part.short.info.directive';
import { ppnPublic } from './ppn.public.directive';
import { ProjectPart } from './ppn.public.resource';
import { routesConfig } from './ppn.public.routes';

import './scss/ppn.scss';

export default angular
  .module('ppn.public', [svgUploadModule.name])
  .directive('ppnPublic', ppnPublic)
  .directive('partPopup', partPopup)
  .directive('projectPartShortInfo', projectPartShortInfo)
  .factory('ProjectPart', ProjectPart)
  .config(routesConfig);
